import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.116,12.321H9.8l2-1.914a.517.517,0,0,0-.357-.891H9.921c-.384-2.932-1.764-5.467-6.287-5.6V2.929a.75.75,0,0,0-1.5,0V13.071a.75.75,0,0,0,.75.75H13.116a.75.75,0,0,0,0-1.5ZM3.634,5.405C6.568,5.5,7.963,6.641,8.4,9.516H6.971a.511.511,0,0,0-.346.888l2.09,1.917H3.634Z';
const draw24px = 'M21.042,20.292H15.393a.755.755,0,0,0,.245-.189l4.135-5a.75.75,0,1,0-1.156-.956l-2.982,3.606A12.6,12.6,0,0,0,3.708,6.454v-3.5a.75.75,0,0,0-1.5,0V21.042a.75.75,0,0,0,.75.75H21.042a.75.75,0,0,0,0-1.5ZM3.708,7.954a11.1,11.1,0,0,1,10.434,9.939l-3.6-2.981a.75.75,0,1,0-.956,1.156l5,4.135a.713.713,0,0,0,.156.089H3.708Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const AngleIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'angle'));
AngleIcon.displayName = 'AngleIcon';
AngleIcon.propTypes = Icon.propTypes;
AngleIcon.renderIcon = props => /*#__PURE__*/React.createElement(AngleIcon, props);
export default AngleIcon;
//# sourceMappingURL=AngleIcon.js.map